import { Checkbox, FormField, FormHelp, Heading, Label, LabeledControl } from '@zillow/constellation-10';
import { Controller, useFormContext } from 'react-hook-form';
import { today } from '../../../../utils/formatters';
import { validateDate } from '../../../../utils/validation';
import { FIELD_IDS } from '../../../../constants/wizard';
import { DatePicker } from '../../../DatePicker';
import { useMount } from 'ahooks';

export function MoveInDateStep() {
  const { getValues, setValue } = useFormContext();
  const isMoveInFlexible = getValues(FIELD_IDS.MOVE_IN_FLEXIBLE);

  useMount(() => {
    if (isMoveInFlexible === null) {
      setValue(FIELD_IDS.MOVE_IN_FLEXIBLE, false);
    }
  });

  return (
    <>
      <Heading level={2} textStyle="heading-sm" css={{ marginBottom: 'default', fontFamily: 'heading-alt' }}>
        Requested move-in date
      </Heading>
      <Controller
        name={FIELD_IDS.MOVE_IN_DATE}
        rules={{
          required: 'Requested move-in date is required',
          validate: (v) =>
            validateDate(v, {
              inTheFuture: true,
            }),
        }}
        render={({ field, fieldState: { error, invalid } }) => (
          <FormField
            label={<Label id="move-in-date-label">Move-in date</Label>}
            description={error && <FormHelp>{error?.message}</FormHelp>}
            error={invalid}
          >
            <DatePicker {...field} minDate={today()} aria-labelledby="move-in-date-label" />
          </FormField>
        )}
      />
      <Controller
        name={FIELD_IDS.MOVE_IN_FLEXIBLE}
        render={({ field: { onChange, value, onBlur } }) => (
          <LabeledControl
            label={<Label>I’m flexible with my move-in date</Label>}
            control={<Checkbox onChange={onChange} name={FIELD_IDS.MOVE_IN_FLEXIBLE} checked={value} onBlur={onBlur} />}
          />
        )}
      />
    </>
  );
}
